export default {
  employees: {
    title: 'Medarbeidere ({{count}} stk)',
    description: 'Administrer hvilke medarbeidere som har tilgang til helseportalen.',
    searchPlaceholder: 'Søk',
    addEmployeeButton: 'Legg til medarbeider',
    employeeAdded: '{{firstName}} {{lastName}} lagt til',
    employeesCreated: '{{count}} medarbeidere lagt til.',
    employeesAlreadyExisting: '{{count}} medarbeidere fantes allerede i systemet.',
    employeesAlreadyExistingNoCount: 'Brukeren finnes allerede i systemet.',
    userDeleted: 'Brukeren slettet',
    deleteUserError: 'Kunne ikke slette brukeren, vennligst prøv igjen.',
    adminPermissionGranted: 'Brukeren har fått administratorrettigheter.',
    adminPermissionRevoked: 'Brukerens administratorrettigheter er fjernet.',
    managerResponsibilityRemoved: 'Medarbeideransvar fjernet.',
    managerResponsibilityAdded: 'Medarbeideransvar lagt til.',
    updateUserError: 'Kunne ikke oppdatere brukeren.',
    deleteDialogTitle: 'Slett bruker',
    deleteDialogUser: 'Bruker {{firstName}} {{lastName}} vil bli slettet permanent.',
    deleteDialogConfirmation: 'Er du sikker på at du vil fortsette?',
    deleteDialogConfirm: 'Fortsett',
  },
  home: {
    title: 'Velkommen til EsterCares helseportal!',
    gettingStartedTitle: 'Tips for å komme i gang',
    manageEmployeesTitle: 'Administrer medarbeidere',
    manageEmployeesDescription: 'Legg til, fjern og administrer medarbeidere i organisasjonen din.',
    womensHealthPolicyTitle: 'Retningslinjer for kvinnehelse',
    womensHealthPolicyDescription: 'Bruk vår mal og utarbeid retningslinjer for kvinnehelse på arbeidsplassen deres.',
    servicesTitle: 'Dine tjenester',
    servicesSeeAll: 'Se alle tjenester',
    participationTitle: 'Deltakelse',
    participationSeeAll: 'Se all statistikk',
    womensHealthTrainingTitle: 'Deltakelse i opplæring om kvinnehelse',
  },
  invoices: {
    title: 'Fakturering',
    comingSoonTitle: 'Støtte for å kunne se fakturaene dine kommer snart!',
    comingSoonMessage: 'I mellomtiden kan du sende e-post til',
    comingSoonEmail: 'hello@estercare.com',
    comingSoonContinue: 'så hjelper vi deg!',
  },
  statistics: {
    title: 'Statistikk',
    description: 'Følg deltakelse og velvære hos de ansatte over tid.',
    summaryTitle: 'Kvinnehelsen hos dere – i tall',
    summaryDescription: 'En oppsummering av hvordan innsatsen påvirker medarbeidernes helse.',
    summaryHighlightIntro: 'Helseprogrammet synliggjør helsebehov og hjelper medarbeidere med å handle på dem.',
    summaryHighlight:
      'Helseprogrammet synliggjør helsebehov og hjelper medarbeidere med å handle på dem. Innen tre måneder rapporterer <bold>{{decreasedSymptomsPct}}%</bold> reduserte symptomer, <bold>{{lifestylePct}}%</bold> har gjort en livsstilsendring og <bold>{{workAbilityPct}}%</bold> opplever forbedret arbeidsevne.',
    summaryImprovedWorkAbility: 'Opplever forbedret arbeidsevne',
    summaryLifestyleChange: 'Har gjort en livsstilsendring',
    summaryDecreasedSymptoms: 'Har reduserte symptomer innen 3 mnd',
    summaryBasedOn: 'Basert på screeninger og oppfølginger.',
    testimonialsTitle: 'I egne ord',
    testimonialsIntro: 'Slik sier medarbeiderne deres det.',
    testimonialsFootnote: 'Sitatene er anonymiserte fritekstsvar fra oppfølgingen.',
    summaryPct: '{{pct}}%',
    notEnoughScreeningData: 'Flere screeninger trengs for å vise denne statistikken.',
    notEnoughFollowUpData: 'Flere oppfølginger trengs for å vise denne statistikken.',
    trainingSection: 'Opplæring',
    womensHealthTrainingChart: 'Deltakelse i opplæring om kvinnehelse',
    moreComingSoon: 'Mer statistikk vil bli vist her fremover.',
    healthProgramTitle: 'Helseprogrammet',
    healthProgramIntro:
      'Helseprogrammet hjelper medarbeideren å gå fra innsikt til handling gjennom personlige anbefalinger om egenomsorg og veiledning til helsehjelp ved behov.',
    participantsTitle: 'Deltakere i helseprogrammet',
    participantsDenominator: 'i helseprogrammet siden start',
    followUpOutcomesTitle: 'Hva helseplanen fører til',
    followUpOutcomesIntro:
      'Mange omsetter helseplanen i handling. {{selfCarePct}}% oppgir at de følger råd om egenomsorg, og {{soughtCarePct}}% blant de som trenger helsehjelp rapporterer at de har tatt neste steg og oppsøkt hjelp.',
    healthPlanRelevanceTitle: 'Opplevde at helseplanen var relevant',
    relevanceCompletely: 'Helt enig',
    relevancePartially: 'Delvis enig',
    relevanceNotAtAll: 'Ikke enig i det hele tatt',
    followedSelfCareTitle: 'Følger råd om egenomsorg',
    soughtCareTitle: 'Har oppsøkt helsehjelp ved behov',
    outcomeImproved: 'Forbedret',
    outcomeUnchanged: 'Uendret',
    outcomeWorsened: 'Forverret',
    outcomeUnit: '%',
    outcomesEyebrow: 'Effekten av tjenesten',
    outcomesIntro: 'Slik endrer plager og arbeidsevne seg etter at en medarbeider har fått sin personlige helseplan.',
    symptomChangeTitle: 'Hvordan plagene endrer seg',
    symptomChangeCaption:
      'Mange plager avtar fra utgangspunktet. Selvrapportert endring ved oppfølging, sammenlignet med screening. Eksempler på vanlige symptomer.',
    symptomMenstrualPain: 'Menssmerter',
    symptomHotFlashes: 'Hetetokter',
    symptomBrainFog: 'Konsentrasjonsvansker',
    symptomSleepDifficulties: 'Søvnproblemer',
    symptomIrritability: 'Irritabilitet',
    productivityChangeTitle: 'Hvordan produktiviteten endrer seg',
    productivityChangeCaption:
      'Selvrapportert endring i produktivitet ved oppfølging, blant de som opprinnelig hadde moderat til høy produktivitetspåvirkning.',
    productivityChangeCaptionWithData:
      '<bold>{{improvedPct}}% opplever forbedret produktivitet</bold> blant dem hvis plager opprinnelig hadde moderat til stor påvirkning på arbeidet. Ytterligere {{unchangedPct}}% opplever at produktiviteten er uendret. (Selvrapportert ved screening og oppfølginger.)',
    competenceTitle: 'Opplæring',
    competenceIntro:
      'Kunnskap hos både medarbeidere og ledere er en viktig del av å skape et mer bærekraftig arbeidsmiljø rundt kvinnehelse. Her vises hvor mange som har påbegynt og gjennomført opplæringene.',
    completionCompleted: 'Gjennomført',
    completionInProgress: 'Pågår',
    completionNotStarted: 'Ikke påbegynt',
    completionUnit: 'personer',
    eligibleCoworkers: 'Alle medarbeidere, {{count}} totalt',
    eligibleManagers: 'Medarbeidere med personalansvar, {{count}} totalt',
    womensHealthTrainingName: 'Grunnopplæring i kvinnehelse',
    managerTrainingName: 'Lederopplæring',
    needsTitle: 'Behovet i organisasjonen deres',
    needsIntro:
      'Screeningen gir et bilde av hvilke plager knyttet til hormonell og gynekologisk helse som finnes blant medarbeiderne som har deltatt, hvor alvorlige plagene er og hvordan de påvirker hverdag og arbeid.',
    needsIntroDetail:
      '<bold>{{severePct}}% av screenede medarbeidere har minst én alvorlig plage og {{carePct}}% anbefales å oppsøke helsehjelp.</bold> Det viser at programmet når personer med konkrete helsebehov og kan hjelpe dem videre til riktig støtte.',
    severityByConditionTitle: 'Vanligste plagene',
    severityByConditionCaptionEmpty: 'Antall kvinner per plage. En kvinne kan ha flere plager.',
    severityByConditionCaption: 'Antall kvinner med plager. En kvinne kan ha flere plager.',
    severityByConditionUnit: 'kvinner',
    conditionPmsPmds: 'PMS & PMDS',
    conditionMenopause: 'Perimenopause & klimakteriet',
    conditionMenstrualPain: 'Menssmerter',
    conditionIncontinence: 'Inkontinens',
    conditionHeavyBleeding: 'Rikelige blødninger',
    impactLow: '0–3 lav',
    impactModerate: '4–6 moderat',
    impactHigh: '7–10 høy',
    workImpactProductivityTitle: 'Påvirkning på produktiviteten i arbeidet',
    workImpactProductivityCaption:
      'Slik svarer kvinnene om hvor mye plagene påvirker produktiviteten, per alvorlighetsgrad',
    workImpactTierMild: 'Lette plager',
    workImpactTierModerate: 'Moderate plager',
    workImpactTierSevere: 'Alvorlige plager',
    workImpactTierMildModerate: 'Lette og moderate plager',
    workImpactTierAll: 'Alle plager',
    percentValue: '{{value}}%',
    ageDistributionTitle: 'Aldersfordeling',
    ageDistributionCaption: 'Alder ved screeningtidspunktet.',
    careLevelTitle: 'Anbefalt å oppsøke helsehjelp',
    severityTitle: 'Har minst ett alvorlig besvær',
    lifePhasesTitle: 'Støtte som følger kvinnen <highlight>gjennom livet</highlight>.',
    lifePhasesDescription:
      'Fra mens og PMS, via graviditet og tiden etter fødsel, til overgangsalderen. EsterCare møter kvinners behov med målrettede tiltak og programmer i hver fase.',
    lifePhasesExample:
      'Eksempel: Anna får tilgang til plattformen ved 26 års alder og møter riktig støtte i hver fase.',
    lifePhasesAge1: '26 år',
    lifePhasesLabel1: 'Mens & PMS',
    lifePhasesAge2: '31 år',
    lifePhasesLabel2: 'Fertilitet & graviditet',
    lifePhasesAge3: '33 år',
    lifePhasesLabel3: 'Etter graviditet',
    lifePhasesAge4: '45 år',
    lifePhasesLabel4: 'Perimenopause',
    lifePhasesAge5: '50 år',
    lifePhasesLabel5: 'Overgangsalderen',
    lifePhasesConditionsLabel: 'Uansett livsfase oppdager vi også sykdom/tilstand som:',
    lifePhasesCondition1: 'Endometriose',
    lifePhasesCondition2: 'PMOS',
    lifePhasesCondition3: 'Skjoldbruskkjertelproblemer',
    lifePhasesCondition4: 'Soppinfeksjon',
    lifePhasesCondition5: 'Vulvodyni',
    exportReport: 'Eksporter rapport',
    exportWarningTitle: 'Før du eksporterer',
    exportUnsupportedText: 'Eksport av rapporten støttes i Chrome og Edge. I andre nettlesere kan oppsettet bli feil.',
    exportInsufficientDataText:
      'Dere har ennå ikke nok data for alle deler av rapporten. Grafer som mangler grunnlag vises med en forklaring i stedet for tall.',
    exportAnyway: 'Eksporter likevel',
    reportGeneratedAt: 'Eksportert {{date}}',
    reportFooter:
      'Rapporten er utarbeidet av EsterCare Workplace Solutions. All statistikk er aggregert, anonymisert og vises bare når datagrunnlaget er stort nok.',
  },
  services: {
    activeTitle: 'Aktiverte tjenester',
    title: 'Tjenester',
    description1: 'Her har vi samlet alle tjenester som inngår i vår helseportal.',
    description2:
      'Som administrator har du mulighet til å enkelt aktivere de tjenestene du ønsker skal inngå i tilbudet deres.',
    addMoreTitle: 'Legg til flere tjenester',
  },
  policy: {
    title: 'Retningslinjer for kvinnehelse',
    description:
      'Her tilbys en mal som kan brukes som utgangspunkt for å utarbeide retningslinjer for deres arbeidsplass.',
    downloadLabel: 'Last ned',
    backgroundTitle: 'Bakgrunn & formål',
    actionsTitle: 'Tiltak',
    principlesTitle: 'Grunnleggende prinsipper',
    responsibilityTitle: 'Ansvar',
    educationSubtitle: 'Opplæring & bevisstgjøring',
    preventiveSubtitle: 'Forebyggende & helsefremmende tiltak',
    workEnvironmentSubtitle: 'Arbeidsmiljø',
    backgroundParagraph1:
      'Kvinner møter ulike helsemessige utfordringer i forskjellige faser av livet, fra reproduktiv helse til overgangsalderen. Plager og sykdommer knyttet til deres gynekologiske og hormonelle helse eksisterer uten tilsvarende hos menn. Kvinnehelse må tas på alvor og vies oppmerksomhet på arbeidsplassen for å sikre at kvinner gis samme forutsetninger for å prestere som menn.',
    backgroundParagraph2:
      'Undersøkelser viser at kvinners helse ofte blir oversett eller marginalisert både innen helse- og omsorgssystemet og på arbeidsplasser. Det er derfor viktig at arbeidsgivere aktivt tar ansvar for å adressere disse behovene og skape et miljø der kvinner føler seg hørt og støttet i sin helse.',
    backgroundParagraph3:
      'Ved å erkjenne at kjønnsspesifikke helseproblemer eksisterer, tar vår bedrift et skritt mot å fremme en mer likestilt og sunn arbeidsplass. Å innføre retningslinjer for kvinnehelse viser vårt engasjement.',
    backgroundParagraph4:
      'Med implementeringen av disse retningslinjene vil vi sikre at våre ansatte får tilgang til relevant informasjon, ressurser og støtte knyttet til kvinnehelse.',
    backgroundParagraph5:
      'Ved å aktivt støtte kvinners helse investerer vi ikke bare i våre ansattes velvære, men også i vår organisasjons langsiktige suksess og bærekraft.',
    principlesParagraph1:
      'Retningslinjene for kvinnehelse har som mål å fremme like forutsetninger for alle ansatte, uavhengig av kjønn, til å prestere og oppleve trivsel på arbeidsplassen. Retningslinjene er utformet for å skape et inkluderende arbeidsmiljø der hvert individ behandles med respekt og gis samme muligheter til å utvikle seg og bidra til selskapets suksess.',
    principlesParagraph2:
      'Alle ansatte skal ha rett til et sunt og trygt arbeidsmiljø. Vi erkjenner at kvinner kan ha spesifikke helsebehov og utfordringer som påvirker deres velvære og prestasjon på arbeidsplassen.',
    principlesParagraph3:
      'Vi forplikter oss til å respektere og verne om alle ansattes integritet og verdighet. Ingen skal bli diskriminert eller behandlet urettferdig på grunn av kjønn, helsetilstand eller andre personlige omstendigheter.',
    principlesParagraph4:
      'Vi arbeider for en åpen og transparent kommunikasjon rundt helsespørsmål. Alle ansatte skal føle seg komfortable med å diskutere helserelaterte bekymringer og få støtte når de trenger det.',
    principlesParagraph5:
      'Vi etterstreber å tilby fleksibilitet og tilpasninger for å møte individuelle helsebehov og fremme en sunn balanse mellom arbeid og privatliv.',
    principlesParagraph6:
      'Vi forplikter oss til kontinuerlig å utdanne og informere alle ansatte om kvinnehelse og likestilling for å skape et mer bevisst og støttende arbeidsmiljø.',
    responsibilityParagraph1:
      'Det er viktig å tydelig definere og fordele ansvar for implementeringen og etterlevelsen av retningslinjene for kvinnehelse på vår arbeidsplass. Nedenfor beskrives hvem som er ansvarlige for ulike deler av retningslinjene:',
    responsibilityManagement: 'Ledergruppen:',
    responsibilityManagementText:
      'Ansvarlig for å fastsette retningslinjenes overordnede mål og føringer samt for å tilby nødvendige ressurser for gjennomføringen.',
    responsibilityHR: 'HR-avdelingen:',
    responsibilityHRText:
      'Har hovedansvaret for å administrere og overvåke implementeringen av retningslinjene. Dette inkluderer å sørge for at retningslinjene kommuniseres til alle ansatte, å gjennomføre opplæring og evalueringer samt å håndtere eventuelle klager eller brudd på retningslinjene.',
    responsibilityManagers: 'Ledere:',
    responsibilityManagersText:
      'Forventes å støtte og fremme retningslinjene blant sine teammedlemmer ved å opptre som forbilder og forkjempere for likestilling og kvinners helse. De er også ansvarlige for å oppmuntre til åpen kommunikasjon og rapportering av eventuelle problemer relatert til retningslinjene.',
    responsibilityEmployees: 'Alle ansatte:',
    responsibilityEmployeesText:
      'Forventes å følge retningslinjene og aktivt bidra til å skape et inkluderende og sunt arbeidsmiljø ved å behandle hverandre med respekt og handle i samsvar med retningslinjenes prinsipper og føringer.',
    principlesParagraph7:
      'Disse retningslinjene gjelder for alle ansatte i selskapet, uavhengig av deres rolle, geografiske plassering eller ansettelsesforhold.',
    actionsIntro:
      'Tiltak omfatter initiativer og ressurser som har til hensikt å forebygge helseproblemer eller redusere risikoen for at de oppstår blant våre kvinnelige ansatte. Dette inkluderer å tilby opplæring for å øke kunnskapen og bryte tabuer, samt å gi helsefremmende støtte når det er behov for det.',
    educationPoint1:
      'Vi tilbyr alle ansatte muligheten til å delta i digital opplæring om kvinnehelse for å sikre at alle får grunnleggende kunnskap om kvinnekroppen og ulike utfordringer knyttet til den.',
    educationPoint2:
      'Vi sikrer også tilgang til vitenskapelig informasjon om kvinnekroppen gjennom artikler og podkastepisoder.',
    educationPoint3:
      'Vi tilbyr alle ledere digital opplæring om kvinnehelse med fokus på hvordan ulike problemer kan påvirke individet og deres mulighet til å utføre arbeidsoppgaver på en fullgod måte.',
    educationPoint4:
      'Vi jobber aktivt for å redusere stigma og tabu knyttet til menstruasjon, overgangsalder og andre temaer relatert til kvinnehelse gjennom åpen kommunikasjon og opplæringstiltak.',
    educationPoint5:
      'Hver leder er ansvarlig for å spre informasjon om og gjennomføring av opplæring for å sikre at vi kontinuerlig forbedrer og fremmer dette arbeidet.',
    preventivePoint1:
      'Vi tilbyr alle kvinnelige ansatte et årlig screeningprogram for kvinnehelse for å identifisere og fange opp symptomer og plager som kan behandles, men som ubehandlet forårsaker unødvendig lidelse og redusert livskvalitet.',
    preventivePoint2:
      'Vi tilbyr alle kvinnelige ansatte muligheten til å få en personlig helseplan som er tilpasset deres unike forutsetninger, utfordringer og behov.',
    preventivePoint3: 'Vi tilbyr alle kvinnelige ansatte helsesamtaler med en jordmor.',
    workEnvironmentPoint1:
      'Vi tilbyr gratis menstruasjonsprodukter på alle toaletter på arbeidsplassen eller til å ta med hvis arbeidet utføres utenfor kontoret.',
    workEnvironmentPoint2:
      'Vi sikrer at våre kvinnelige ansatte har tilgang til toaletter med rennende vann i løpet av arbeidsdagen.',
    workEnvironmentPoint3:
      'Vi tilbyr fleksible arbeidstidsordninger, mulighet for hjemmekontor og korte pauser for å håndtere plager knyttet til kvinnehelse. I tillegg kan helsesamtaler, legebesøk eller besøk innenfor rammen av nasjonale screeningprogrammer knyttet til kvinnehelse gjennomføres i arbeidstiden.',
    principleRespect: 'Respekt og verdighet:',
    principleRespectText:
      'Vi etterstreber å behandle alle medarbeidere med respekt og verdighet uavhengig av alder eller kjønn. Vi fremmer et inkluderende arbeidsmiljø der likestilling verdsettes, helsetilstander ikke bagatelliseres eller latterliggjøres, og der alle har rett til like muligheter.',
    principleNonDiscrimination: 'Forebygging av diskriminering og latterliggjøring:',
    principleNonDiscriminationText:
      'Vi forventer at alle ansatte viser respekt og toleranse overfor hverandre og handler kraftfullt hvis de observerer diskriminerende eller latterliggjørende atferd. Vi tar slike situasjoner på alvor og undersøker alle anklager for å sikre at passende tiltak iverksettes.',
    principleInclusive: 'Inkluderende arbeidsplass:',
    principleInclusiveText:
      'Vi streber etter å være en inkluderende arbeidsplass der alle ansatte behandles likt og gis samme forutsetninger. Vi jobber aktivt med å fremme en kultur preget av åpenhet og forståelse hvor alle ansatte føler seg komfortable med å snakke om forhold som påvirker arbeidsprestasjonen.',
  },
  service: {
    priceProposalMobile: 'Få et pristilbud',
    priceProposalDesktop: 'Få et pristilbud og aktiver tjenesten for deres ansatte',
    activeStatus: 'AKTIV',
    loadingMessage: 'Vennligst vent mens vi behandler forespørselen din.',
    successTitle: 'Vi har mottatt forespørselen din!',
    successDescription:
      'Innen 1-2 arbeidsdager kommer vi tilbake med et pristilbud. Deretter hjelper vi dere med å raskt og enkelt komme i gang med tjenesten i organisasjonen deres.',
    errorTitle: 'Noe gikk galt',
    errorDescription: 'Prøv igjen eller kontakt vår support.',
  },
  certification: {
    pageTitle: 'Sertifisering',
    title: 'Equal Health Certification',
    description:
      'Equal Health Certification er en kvalitetsmerking for arbeidsplasser som vil arbeide strukturert med kvinnehelse og likestilt helse.\nSertifiseringen hjelper dere med å forstå hvor organisasjonen står i dag, synliggjør det dere allerede gjør bra, og identifiserer områder dere kan utvikle.\n\nNeste steg er å fylle ut sertifiseringsundersøkelsen. Du svarer på spørsmål på vegne av organisasjonen, og basert på svarene settes det sammen en rapport med styrker og forbedringsområder. Dere får også konkrete anbefalinger som hjelper dere med å prioritere neste steg og skape langsiktig endring.',
    consentText:
      'Ved å fortsette samtykker du til at EsterCare behandler og lagrer opplysningene du oppgir i sertifiseringsundersøkelsen.',
    startButton: 'Start sertifiseringen',
    continueButton: 'Fortsett med sertifiseringen',
    uploadTitle: 'Legg ved policyen deres for kvinnehelse',
    uploadDescription:
      'Legg ved policyen deres som PDF, så tar teamet vårt hensyn til den i vurderingen. Dere kan hoppe over dette steget hvis dere ikke har noen policy å legge ved.',
    uploadFileTooLarge: 'Filen er for stor. Hver fil kan være maks {{maxSize}} MB.',
    uploadTooManyFiles: 'Dere kan legge ved maks {{maxFiles}} filer.',
    uploadWrongFileType: 'Bare PDF-filer kan legges ved.',
    uploadRejected: 'Filen kunne ikke legges ved. Prøv en annen fil.',
    removeDocument: 'Fjern {{fileName}}',
    submitTitle: 'På tide å sende inn',
    submitDescription:
      'Alle spørsmål er nå besvart. Når vurderingen er klar, kan du se rapporten deres, med styrker, forbedringsområder og anbefalte neste steg.',
    submitNextSteps: 'Vi tar kontakt på e-post når den er tilgjengelig i portalen.',
    submitButton: 'Send inn svarene',
    previousQuestionError: 'Vi kunne ikke hente forrige spørsmål. Prøv igjen.',
    submittedTitle: 'Takk!',
    submittedDescription: 'Vi tar kontakt så snart resultatene deres er klare.',
    pendingTitle: 'Svarene deres behandles',
    pendingDescription: 'Dere får en e-post når rapporten er klar',
    resultsTitle: 'Equal Health Certification',
    resultsDescription:
      'En kvalitetsmerking for likestilt helse på arbeidsplassen - basert på globale standarder. Den veileder arbeidsgivere i å skape tryggere, sunnere og mer inkluderende arbeidsplasser for kvinner.',
    notAchievedCertification: 'Organisasjonen deres har ennå ikke oppnådd Equal Health Certification',
    achievedCertification: 'Organisasjonen deres har oppnådd Equal Health {{level}}',
    downloadLogo: 'Last ned logo',
    levelBadge: 'LEVEL {{level}}',
    foundationTitle: 'Equal Health Foundation',
    foundationDescription:
      'Organisasjonen deres har tatt viktige første steg mot å integrere kvinnehelse i arbeidsplassens retningslinjer og arbeidsmåter. Dette nivået anerkjenner bevissthet, tidlige initiativer og en tydelig vilje til å skape et mer inkluderende og støttende arbeidsmiljø for alle ansatte.',
    advancedTitle: 'Equal Health Advanced',
    advancedDescription:
      'Organisasjonen deres har innført strukturerte rutiner og en aktiv tilnærming til kvinnehelse som gjennomsyrer flere deler av virksomheten. Dette nivået viser et tydelig engasjement og kontinuerlig arbeid for en mer likestilt og helsefremmende arbeidsplass.',
    excellenceTitle: 'Equal Health Excellence',
    excellenceDescription:
      'Organisasjonen deres er ledende innen kvinnehelse på arbeidsplassen og har gjort dette til en naturlig del av kulturen og strategien. Dette nivået representerer det høyeste engasjementet for et trygt, inkluderende og helsefremmende arbeidsmiljø for alle ansatte.',
    reportTitle: 'Rapport',
    reportDescription:
      'Her finner dere sertifiseringsrapporten deres, som viser resultatet av EsterCares gjennomgang av organisasjonens arbeid med kvinnehelse på arbeidsplassen. Rapporten viser sertifiseringsnivået deres, en oppsummering av styrkene deres samt konkrete forbedringsområder innen de fire vurderte områdene: policy og styring, arbeidsmiljø og tilpasninger, kompetanse og kultur samt helsetiltak og fleksibilitet.',
    reportDownloadCta:
      'Last ned rapporten for å ta del av den fullstendige vurderingen og anbefalingene for neste steg.',
    downloadReport: 'Last ned rapporten',
    nextStepsTitle: 'Anbefalte neste steg',
  },
  support: {
    questionsTitle: 'Har du spørsmål eller tanker?',
    contactMessage: 'Send e-post til',
    contactEmail: 'hello@estercare.com',
    contactContinue: 'så hjelper vi deg!',
  },
} as const
